webpackJsonp([35],{

/***/ "4kpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_not_found_js__ = __webpack_require__("urbP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28fd82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_not_found_vue__ = __webpack_require__("vEwY");
function injectStyle (ssrContext) {
  __webpack_require__("XkKR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_not_found_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28fd82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_not_found_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ESWh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}.page-not-found{-webkit-box-shadow:0 20px 50px 0 rgba(0,0,0,.1);box-shadow:0 20px 50px 0 rgba(0,0,0,.1)}@media screen and (min-width:56.875em){.page-not-found{padding:18px 0 0}}.page-not-found__content{background-color:#fff;padding:20px;margin-top:10px}@media screen and (min-width:56.875em){.page-not-found__content{padding:40px 100px}}.page-not-found__header-main{text-align:center}.page-not-found__header-secondary{text-align:center;font-size:12px}@media screen and (min-width:56.875em){.page-not-found__header-secondary{font-size:20px}}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/pages/page-not-found/page-not-found.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,gBACE,gDAAqD,AAC7C,uCAA6C,CACtD,AACD,uCACA,gBACM,gBAAkB,CACvB,CACA,AACD,yBACI,sBAAuB,AACvB,aAAc,AACd,eAAiB,CACpB,AACD,uCACA,yBACQ,kBAAoB,CAC3B,CACA,AACD,6BACI,iBAAmB,CACtB,AACD,kCACI,kBAAmB,AACnB,cAAgB,CACnB,AACD,uCACA,kCACQ,cAAgB,CACvB,CACA","file":"page-not-found.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n.page-not-found {\n  -webkit-box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.1);\n}\n@media screen and (min-width: 56.875em) {\n.page-not-found {\n      padding: 18px 0 0;\n}\n}\n.page-not-found__content {\n    background-color: #fff;\n    padding: 20px;\n    margin-top: 10px;\n}\n@media screen and (min-width: 56.875em) {\n.page-not-found__content {\n        padding: 40px 100px;\n}\n}\n.page-not-found__header-main {\n    text-align: center;\n}\n.page-not-found__header-secondary {\n    text-align: center;\n    font-size: 12px;\n}\n@media screen and (min-width: 56.875em) {\n.page-not-found__header-secondary {\n        font-size: 20px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "XkKR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ESWh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4493adfc", content, true, {});

/***/ }),

/***/ "urbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_seoMeta__ = __webpack_require__("08z+");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_seoMeta__["a" /* default */]],
  components: {
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_0__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return this.buildSeoMeta({
      title: 'Page Not Found',
      extraMeta: [{ name: 'prerender-status-code', content: '404' }, { name: 'robots', content: 'noindex,nofollow' }]
    });
  }
});

/***/ }),

/***/ "vEwY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('static-page-header',{attrs:{"theme":"dark"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      "+_vm._s(_vm.$route.query.status === '429' ? 'Too Many Requests' : 'Page Not Found')+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"page-not-found__content"},[_c('h1',{staticClass:"page-not-found__header-main"},[_vm._v("\n      Error "+_vm._s(_vm.$route.query.status || '404')+"\n    ")]),_vm._v(" "),_c('h3',{staticClass:"page-not-found__header-secondary"},[_vm._v("\n      "+_vm._s(_vm.$route.query.status === '429' ? 'Too many requests. Try again later.' : "Whoops. It looks as if this page doesn't exist.")+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/35.f1cf13f1b281de9255ff.js